// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Hammer from '../third/hammer.min';

const fragments = {
    PRODUCT: '[data-fragment="EshopImageZoom.imageState"]',
    IMG_WRAP: '[data-fragment="EshopImageZoom.imageWrap"]',
    IMG: '[data-fragment="EshopImageZoom.img"]',
    PLUS: '[data-fragment="EshopImageZoom.plus"]',
    MINUS: '[data-fragment="EshopImageZoom.minus"]',
    PERCENTAGE: '[data-fragment="EshopImageZoom.percentage"]'
};

export default class EshopImageZoom extends WebComponent {
    didMount() {
        const product = this.element.querySelector(fragments.PRODUCT);
        const imgWrap = this.element.querySelector(fragments.IMG_WRAP);
        const img = this.element.querySelector(fragments.IMG);
        const plus = this.element.querySelector(fragments.PLUS);
        const minus = this.element.querySelector(fragments.MINUS);
        const percentage = this.element.querySelector(fragments.PERCENTAGE);
        const windowWidth = window.innerWidth;
        let isDown = false;
        let startX;
        let startY;
        let panX = 0;
        let panY = 0;
        let minPanX = (window.innerWidth / 2) * (-1);
        let maxPanX = (window.innerWidth / 2);
        let minPanY = (window.innerHeight / 2) * (-1);
        let maxPanY = (window.innerHeight / 2);
        let scale = 1;
        let percentageValue = 0;
        const maximumScale = 2;
        let holdZoomIn = false;
        let holdZoomOut = false;
        let holdZoomSpeed = 150;

        if(document.querySelector('.eshop-gallery--popup') && is_touch_enabled() && windowWidth < 992) {
            scale = maximumScale;
            percentageValue = 100;
            img.style.transform = 'scale('+scale+')';
            setPercentage();
        }

        plus.addEventListener('mousedown', (e) => {
            zoomIn();
            startZoomIn();
        });

        plus.addEventListener('mouseup', (e) => {
            clearInterval(holdZoomIn);
        });

        minus.addEventListener('mousedown', (e) => {
            zoomOut();
            startZoomOut();
        });

        minus.addEventListener('mouseup', (e) => {
            clearInterval(holdZoomOut);
        });

        function startZoomIn() {
            holdZoomIn = setInterval(function() {
                zoomIn();
            }, holdZoomSpeed);
        }

        function zoomIn() {
            product.classList.add('zoom-in');
            if (scale < maximumScale) {
                scale = scale + 0.25;
                percentageValue = percentageValue + 25;
            }
            img.style.transform = 'scale('+scale+')';
            setPercentage();
        }

        function startZoomOut() {
            holdZoomOut = setInterval(function() {
                zoomOut();
            }, holdZoomSpeed);
        }

        function zoomOut() {
            product.classList.remove('zoom-in');
            if (scale > 1) {
                scale = scale - 0.25;
                percentageValue = percentageValue - 25;
            }
            img.style.transform = 'scale('+scale+')';
            setPercentage();
        }

        function getPositions(e) {

            isDown = true;

            if (e.type == 'panstart') {
                startX = e.center.x - panX;
                startY = e.center.y - panY;
            } else {
                startX = e.pageX - panX;
                startY = e.pageY - panY;
            }

            product.classList.add('zoom-in');

        }

        function disable(e) {
            isDown = false;
        }

        function zoomPan(e) {

            if(!isDown) return; //stop fn if mouse is not dowm
            if(!document.querySelector('.eshop-gallery--popup')) return;

            e.preventDefault();

            if (e.type == 'panmove') {
                panX = e.center.x - startX;
                panY = e.center.y - startY;
            } else {
                panX = e.pageX - startX;
                panY = e.pageY - startY;
            }

            if (panX <= minPanX) panX = minPanX;
            if (panX >= maxPanX) panX = maxPanX;
            if (panY <= minPanY) panY = minPanY;
            if (panY >= maxPanY) panY = maxPanY;

            imgWrap.style.transform = 'translateX(' + panX + 'px' + ') translateY(' + panY + 'px' + ')';
        }

        function setPercentage() {
            percentage.innerText = percentageValue + '%';
            minus.classList.remove('eshop-gallery__zoom-control-item--disabled');
            plus.classList.remove('eshop-gallery__zoom-control-item--disabled');
            if (percentageValue == 0) {
                minus.classList.add('eshop-gallery__zoom-control-item--disabled');
                clearInterval(holdZoomOut);
            }
            if (percentageValue == 100) {
                plus.classList.add('eshop-gallery__zoom-control-item--disabled');
                clearInterval(holdZoomIn);
            }
        }

        function pinch(e) {
            disable();
            if (e.scale > 1) scale = scale + e.scale;
            if (e.scale < 1) scale = scale - e.scale;
            if (scale > maximumScale) scale = maximumScale;
            if (scale < 1) scale = 1;
            img.style.transform = 'scale('+scale+')';
        }

        function is_touch_enabled() {
            return ( 'ontouchstart' in window ) ||
                ( navigator.maxTouchPoints > 0 ) ||
                ( navigator.msMaxTouchPoints > 0 );
        }

        if (is_touch_enabled() && windowWidth < 1400) {
            // pinch
            const hammertime = new Hammer(product);
            hammertime.get('pinch').set({ enable: true });
            hammertime.on('pinch', pinch);

            // pan
            hammertime.on('panstart', getPositions);
            hammertime.on('panend', disable);
            hammertime.on('pancancel', disable);
            hammertime.on('panmove', zoomPan);
        } else {
            // Desktop
            product.addEventListener("mousedown", getPositions);
            product.addEventListener("mouseup", disable);
            product.addEventListener("mouseleave", disable);
            product.addEventListener("mousemove", zoomPan);
        }
    }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopImageZoom.js